import React, { useState, useEffect } from "react";
import { Box, Typography, Button, IconButton, Tooltip, TextField, MenuItem, CircularProgress, Grid, Dialog, DialogTitle, DialogContent, DialogActions, Table, TableBody, TableRow, TableCell } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import DataTable from "../components/DataTable";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import SnackbarAlert from "../components/SnackbarAlert";
import VisibilityIcon from "@mui/icons-material/Visibility";
export default function UserPlanList() {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [search, setSearch] = useState("");
    const [open, setOpen] = useState(false);
    const [editState, setEditState] = useState(null);
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [amount, setAmount] = useState("");
    const [rateDate, setRateDate] = useState(new Date());
    const [planDurationType, setPlanDurationType] = useState();
    const [transactionId, setTransactionId] = useState("");
    const [selectedItem, setSelectedItem] = useState([]);
    const [openPreview, setOpenPreview] = useState(false);
    useEffect(() => {
        fetchUserstData();
    }, []);
    const fetchUserstData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "user-plans/all";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openEdit = async (data) => {
        setEditState(data);
        setOpen(true);
    };
    const handleSave = async () => {
        const planAmount = Number(editState?.installment_amount || 0);
        const enteredAmount = amount;
        if (enteredAmount > planAmount) {
            setMessage(`Payment amount cannot exceed plan amount ₹${planAmount}`);
            setSnackbar(true);
            return;
        }
        if (planDurationType === "GPay" && !transactionId?.trim()) {
            setMessage("Transaction ID is required for GPay");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        const planAmountData = {
            user_plan_id: editState?.rfId,
            installment_no: editState?.completed_installments + 1,
            amount_paid: amount,
            payment_method: planDurationType,
            transaction_reference: transactionId
        };
        try {
            let url = webEndPoint + "payments/pay";
            const response = await makeRequest("post", url, planAmountData);
            if (response) {
                setLoading(false);
                setMessage("User Payment Added Successfully");
            }
            fetchUserstData();
            setSnackbar(true);
            setOpen(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const formatDate = (date) => {
        return new Date(date).toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });
    };
    const filteredData = dataSource?.filter((d) =>
        d?.user_name?.toLowerCase().includes(search?.toLowerCase()) || d?.mobile_number?.toLowerCase().includes(search?.toLowerCase())
    );
    const handleView = async (item) => {
        setSelectedItem(item);
        setOpenPreview(true);
    }
    const columns = ["S.No", "User Name", "Mobile", "Plan Type", "Plan Name", "Plan Amount", "Action"];
    const rows = filteredData?.map((u, i) => [i + 1, u.user_name, u.mobile_number, u.plan_type, u.saving_plan_name + " (" + u.plan_category_name + ")", u.installment_amount,
    <Box>
        <Tooltip title="Edit">
            <IconButton color="primary" onClick={() => openEdit(u)}>
                <EditIcon />
            </IconButton>
        </Tooltip>
        <Tooltip title="Preview">
            <IconButton color="info" onClick={() => handleView(u)}><VisibilityIcon /></IconButton>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>Savings Scheme List</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search User Name / Mobile Number" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
            </Box>
            <DataTable columns={columns} rows={rows} loading={false} />

            {open && (
                <Box sx={{ position: "fixed", top: 50, left: 0, width: "100%", height: "100%", bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1200 }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: 1000, maxHeight: "75vh", overflowY: "auto" }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>{editState !== null ? "Plan Payment Entry" : "Plan Payment Entry"}</Typography>
                        <Box sx={{ mb: 3, p: 2, bgcolor: "#f5f5f5", borderRadius: 1 }}>
                            <Typography>User Name: {editState?.user_name}</Typography><br />
                            <Typography>Mobile No: {editState?.mobile_number}</Typography><br />
                            <Typography>Plan Name: {editState?.saving_plan_name}</Typography><br />
                            <Typography>Monthly Amount: ₹{editState?.installment_amount}</Typography>
                        </Box>
                        <TextField label="Amount" type="number" value={amount} onChange={(e) => setAmount(e.target.value)} sx={{ mb: 2 }} fullWidth />
                        <TextField select label="Payment Type" name="type" fullWidth value={planDurationType} onChange={(e) => setPlanDurationType(e.target.value)} sx={{ mb: 2 }}>
                            <MenuItem value="Cash">Cash</MenuItem>
                            <MenuItem value="GPay">GPay</MenuItem>
                        </TextField>
                        {planDurationType === "GPay" && (
                            <TextField
                                label="Transaction ID"
                                value={transactionId}
                                onChange={(e) => setTransactionId(e.target.value)}
                                sx={{ mb: 2 }}
                                fullWidth />
                        )}
                        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
                            <Button onClick={() => setOpen(false)}>Cancel</Button>
                            <Button variant="contained" onClick={handleSave}>Save</Button>
                        </Box>
                    </Box>
                </Box>
            )}
            <Dialog open={openPreview} onClose={() => setOpenPreview(false)} maxWidth="lg" fullWidth>
                <DialogTitle sx={{ fontWeight: 600, fontSize: 24 }}>Details</DialogTitle>
                <DialogContent>
                    <Table sx={{ border: "1px solid #e0e0e0", borderRadius: 2, overflow: "hidden" }}>
                        <TableBody>
                            <TableRow>
                                <TableCell sx={{ width: "15%", fontWeight: 600, bgcolor: "#f5f5f5" }}>User Name</TableCell>
                                <TableCell sx={{ width: "42%", border: "1px solid #e0e0e0", bgcolor: "#f5f5f5" }}>{selectedItem?.user_name}</TableCell>
                                <TableCell sx={{ width: "15%", fontWeight: 600, bgcolor: "#f5f5f5" }}>Mobile Number</TableCell>
                                <TableCell sx={{ width: "42%", border: "1px solid #e0e0e0", bgcolor: "#f5f5f5" }}>{selectedItem?.mobile_number}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ width: "15%", fontWeight: 600, bgcolor: "#f5f5f5" }}>Plan Name</TableCell>
                                <TableCell sx={{ width: "42%", border: "1px solid #e0e0e0", bgcolor: "#f5f5f5" }}>{selectedItem?.saving_plan_name} ({selectedItem?.plan_category_name})</TableCell>
                                <TableCell sx={{ width: "15%", fontWeight: 600, bgcolor: "#f5f5f5" }}>Plan Duration</TableCell>
                                <TableCell sx={{ width: "42%", border: "1px solid #e0e0e0", bgcolor: "#f5f5f5" }}>{selectedItem?.plan_duration} {selectedItem.plan_type === 'MONTHLY' ? "Months" : "Weeks"}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ width: "15%", fontWeight: 600, bgcolor: "#f5f5f5" }}>Plan Start Date</TableCell>
                                <TableCell sx={{ width: "42%", border: "1px solid #e0e0e0", bgcolor: "#f5f5f5" }}>{formatDate(selectedItem?.enrollment_date)}</TableCell>
                                <TableCell sx={{ width: "15%", fontWeight: 600, bgcolor: "#f5f5f5" }}>Next Due Date</TableCell>
                                <TableCell sx={{ width: "42%", border: "1px solid #e0e0e0", bgcolor: "#f5f5f5" }}>{formatDate(selectedItem?.next_due_date)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ width: "15%", fontWeight: 600, bgcolor: "#f5f5f5" }}>Completed Due</TableCell>
                                <TableCell sx={{ width: "42%", border: "1px solid #e0e0e0", bgcolor: "#f5f5f5" }}>{selectedItem?.completed_installments}</TableCell>
                                <TableCell sx={{ width: "15%", fontWeight: 600, bgcolor: "#f5f5f5" }}>Total Paid Amount</TableCell>
                                <TableCell sx={{ width: "42%", border: "1px solid #e0e0e0", bgcolor: "#f5f5f5" }}>{selectedItem?.total_paid_amount}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ width: "15%", fontWeight: 600, bgcolor: "#f5f5f5" }}>Saved Weight</TableCell>
                                <TableCell sx={{ width: "42%", border: "1px solid #e0e0e0", bgcolor: "#f5f5f5" }}>{selectedItem?.total_metal_weight} grams</TableCell>
                                <TableCell sx={{ width: "15%", fontWeight: 600, bgcolor: "#f5f5f5" }}>Plan Current Status</TableCell>
                                <TableCell sx={{ width: "42%", border: "1px solid #e0e0e0", bgcolor: "#f5f5f5" }}>{selectedItem?.status}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={() => setOpenPreview(false)}>Close</Button>
                </DialogActions>
            </Dialog>
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
        </Box>
    );
}